import { render, staticRenderFns } from "./CourseOverview.vue?vue&type=template&id=27453622&"
import script from "./CourseOverview.vue?vue&type=script&lang=js&"
export * from "./CourseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBlobBackground: require('/opt/build/repo/components/UI/BlobBackground.vue').default,CoursesYoutube: require('/opt/build/repo/components/Courses/Youtube.vue').default})
